import React, { useState } from 'react';
import "./Products.css";

const Products = () => {

    const [activeTab, setActiveTab] = useState("history");

    return (
        <div className="content">
            <h3 className="heading">Our Business</h3>
            <div className='products-tabs'>
                <ul className='products-nav'>
                    <TabNavItem title="OUR BUSINESS" id="history" activeTab={activeTab} setActiveTab={setActiveTab} />
                    <TabNavItem title="REGIONAL OPERATIONS CENTERS" id="mission" activeTab={activeTab} setActiveTab={setActiveTab} />
                    {/* <TabNavItem title="By Name" id="by_name" activeTab={activeTab} setActiveTab={setActiveTab} />
                    <TabNavItem title="By Region" id="by_region" activeTab={activeTab} setActiveTab={setActiveTab} />
                    <TabNavItem title="By Constituency" id="by_constituency" activeTab={activeTab} setActiveTab={setActiveTab} />
                    <TabNavItem title="By Branch" id="by_branch" activeTab={activeTab} setActiveTab={setActiveTab} />
                    <TabNavItem title="By Profession" id="by_profession" activeTab={activeTab} setActiveTab={setActiveTab} />
                    <TabNavItem title="By Qualification" id="by_qualification" activeTab={activeTab} setActiveTab={setActiveTab} /> */}
                </ul>
                <div className='outlet'>
                    <TabContent id="history" activeTab={activeTab}>
                        < Pension1/>
                    </TabContent>
                    <TabContent id="mission" activeTab={activeTab}>
                        < Pension2/>
                    </TabContent>
                    {/* <TabContent id="by_mobile_number" activeTab={activeTab}>
                        <ByMobile />
                    </TabContent>
                    <TabContent id="by_name" activeTab={activeTab}>
                        <ByName />
                    </TabContent>
                    <TabContent id="by_region" activeTab={activeTab}>
                        <ByRegion />
                    </TabContent>
                    <TabContent id="by_constituency" activeTab={activeTab}>
                        <ByConstituency />
                    </TabContent>
                    <TabContent id="by_branch" activeTab={activeTab}>
                        <ByBranch />
                    </TabContent>
                    <TabContent id="by_profession" activeTab={activeTab}>
                        <ByProfession />
                    </TabContent>
                    <TabContent id="by_qualification" activeTab={activeTab}>
                        <ByQualification />
                    </TabContent> */}
                </div>
            </div>
        </div>
    )
}
export default Products

function TabNavItem({ id, title, activeTab, setActiveTab }) {
    const handleClick = () => {
        setActiveTab(id);
    };
    return (
        <li onClick={handleClick} className={activeTab === id ? "active" : ""}>
            {title}
        </li>
    )
}

function TabContent({ id, activeTab, children }) {
    return (
        activeTab === id ? <div className='TabContent'>
            {children}
        </div>
            : null
    )
}


function Pension1() {
    return (
        <div className='history'>
            <h1>OUR BUSINESS </h1>
            <p>The primary activity of NTHC Commodities is the purchase and sale of cocoa beans.</p>
            <p>Our regional representatives source high-quality cocoa beans from trusted farmers with whom we have long-term relationships, which are then delivered to our various designated warehouses across the country and handed over to Cocobod's subsidiary, the Cocoa Marketing Company (CMC).</p>

            {/* <h1>FEATURES OF ACT 766</h1>
            <ul>
                <li>
                    <p>
                        <strong>• Tier 1 - </strong>A mandatory basic contributory Social Security Scheme managed by SSNIT.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>• Tier 2 - </strong>A mandatory fully-funded and privately managed occupational scheme.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>• Tier 3 - </strong>A voluntary fully-funded and privately managed personal pension plan and provident fund.
                    </p>
                </li>
            </ul><br />
            <h1>CONTRIBUTION RATES UNDER THE OCCUPATION PENSION SCHEME (Tier 2)</h1>
            <ul>
                <li>
                    <p>
                        <strong>• Employer –</strong>13.0% of employee basic salary
                    </p>
                </li>
                <li>
                    <p>
                        <strong>• Employee –</strong>5.5% of from basic salary
                    </p>
                </li>
                <li>
                    <p>
                        <strong>•</strong> Out of the total 18.5%, the employer remits 5% to NTHC Trustees Tier 2 Mandatory Occupational Scheme. 13.5% is remitted to SSNIT. 
                    </p>
                </li>
                <li>
                    <p>
                        <strong>•</strong> The employer remits total 18.5% to NTHC Trustees Tier 2 Mandatory Occupational Scheme for employees exempted from Tier 1 (age 45+)
                    </p>
                </li>
                <li>
                    <p>
                        <strong>•</strong> Entry Age of joining the scheme– 15 years (minimum) and 59 years (maximum) only for new entrants.
                    </p>
                </li>
            </ul><br />
            <h1>BENEFITS</h1>
            <ul>
                <li>
                    <p>
                        <strong>•</strong> Old Age Lump Sum 
                    </p>
                </li>
                <li>
                    <p>
                        <strong>•</strong> Invalidity Benefit 
                    </p>
                </li>
                <li>
                    <p>
                        <strong>•</strong> Survivors Lump Sum 
                    </p>
                </li>
                <li>
                    <p>
                        <strong>•</strong> Emigration Benefit 
                    </p>
                </li>
            </ul><br />
            <h1>QUALIFYING CONDITIONS</h1>
            <ul>
                <li>
                    <p>
                        <strong>•</strong> Must be between 50 and 60 years to benefit
                    </p>
                </li>
                <ul>
                    <li>
                        <p>
                            <strong>-</strong> Retirement is at age 60 and above
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>-</strong> Early Retirement is from age 55 to 59
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong>-</strong> Unemployed is from age 50 to 59
                        </p>
                    </li>
                </ul>
            </ul><br /> */}
        </div>
    )
}
function Pension2() {
    return (
        <div className='mission'>
            <h1>REGIONAL OPERATIONS CENTERS (Earmarked by Cocobod)</h1>  
            <table className='table table-bordered table-striped'>
                <thead>
                    <tr>
                        <th>Central </th>
                        <th>Ashanti</th>
                        <th>Brong-Ahafo</th>
                        <th>Western North</th>
                        <th>Western South</th>
                        <th>Eastern</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Assin Fosu A&B</td>
                        <td>Juaso</td>
                        <td>Goaso A&B</td>
                        <td>Debiso</td>
                        <td>Wassa Akropong</td>
                        <td>Ofoase</td>
                    </tr>
                    <tr>
                        <td>Assin Breku A&B</td>
                        <td>Edubiase</td>
                        <td>Sunyani</td>
                        <td>Fosukrom A&B</td>
                        <td>Bogoso</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Breman Asikuma A-D</td>
                        <td>Ashanti Bekwai</td>
                        <td>Dormaa Ahenkro</td>
                        <td>Asempaneye</td>
                        <td>Tarkwa</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Nyankomase</td>
                        <td>Effiduase</td>
                        <td>Asumura</td>
                        <td>Dadieso A&B</td>
                        <td>Elubo/Anyinasie</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Antoakrom</td>
                        <td>Nkrankwanta A&B</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Obuasi</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Nsokote</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

        </div>
    )
}

function Functions() {
    return (
        <div className='core-functions'>
            <h1>Why Us?</h1>

            <p>
                NTHC Trustees is setting standards in pensions delivery on many fronts. Through meticulous investments, we provide highly competitive returns on investments and we have the ability to provide customers with adequate and speedy benefits processing at retirement.</p>
            <p>The added advantage of choosing NTHC Trustees as a corporate trustee is the wide network coverage reaching out to highly remote areas of Ghana. We have experienced, highly skilled and dedicated staff as well as other stakeholders to give customers great value.
            </p>
        </div>
    )
}
function Board() {
    return (
        <div className='board-composition'>
            <h1>Board of Directors</h1>
            <p> The Board of Directors are responsible for the policy direction of Company.</p>
            <div className='sub-board'>
                <div className="sub-board-card">
                    <div className='sub-board-image'>
                        <img alt='boardImg' src="/images/board/Isaac_Charles_Acquah.png" />
                    </div>
                    <h3>Isaac Charles Acquah</h3>
                    <h4> Board Member</h4>
                </div>
                <div className="sub-board-card">
                    <div className='sub-board-image'>
                        <img alt='boardImg' src="/images/board/Kofi_Agyeman_Boakye.png" />
                    </div>
                    <h3>Kofi-AgyemanBoakye</h3>
                    <h4>Board Member</h4>
                </div>
                <div className="sub-board-card">
                    <div className='sub-board-image'>
                        <img alt='boardImg' src="" />
                    </div>
                    <h3></h3>
                    <h4></h4>
                </div>
            </div>
        </div>
    )
}
function Shareholders() {
    return (
        <div className='shareholders'>
            <h1> Our Shareholders</h1>
            <div className="shareholders-card">
                <div className="holders-card">
                    <div className="col-md-2 logo-image">
                        <figure>
                            <img src="/images/shareholders/ssnit_logo.jpg" alt="SSNIT Logo" width="512" height="512" />
                        </figure>
                    </div>
                    <div>
                        <div><h3>Social Security and National Insurance Trust (SSNIT)</h3></div>

                        <div><p>The Social Security and National Insurance Trust (SSNIT), established in 1972, is a statutory public Trust
                            charged under the National Pensions Act 2008 Act 766 with the administration of Ghana’s Basic National
                            Social Security Pension Scheme and to cater for the first tier of the contributory three-tier scheme. Today
                            it manages one of the largest asset portfolios in Ghana. SSNIT currently holds <strong>75%</strong> shareholding in NTHC Limited.</p></div>
                    </div>
                </div>
                <div className="holders-card">
                    <div className="col-md-2 logo-image">
                        <figure>
                            <img src="/images/shareholders/nib.png" alt="NIB Logo" width="512" height="512" />
                        </figure>
                    </div>
                    <div>
                        <div><h3>Investment Bank (NIB)</h3></div>
                        <div>
                            <p>National Investment Bank (NIB), was incorporated in 1963 as an autonomous joint state-private institution
                                primarily to promote and strengthen rapid industrialization in all sectors of the Ghanaian economy. Today it
                                is one of the oldest established banks in the country. NIB currently holds <strong>8.71%</strong>
                                shareholding in NTHC Limited.</p>
                        </div>
                    </div>
                </div>
                <div className="holders-card">
                    <div className="col-md-2 logo-image">
                        <figure>
                            <img src="/images/shareholders/sic_logo.png" alt="SIC Logo" width="512" height="512" />
                        </figure>
                    </div>
                    <div>
                        <div><h3>Insurance Company Limited (SIC)</h3></div>
                        <div>
                            <p>State Insurance Company Limited (SIC) traces its roots to 1955. It is the nation’s largest insurer and
                                the
                                only one with a nationwide coverage. The Company has consistently maintained a steady market leadership
                                and
                                currently holds considerable market share in both the general and life insurance business. SIC currently
                                holds <strong>8.71%</strong> shareholding in NTHC Limited.</p>
                        </div>
                    </div>
                </div>



                <h3>AcreCon Limited</h3>
                <div className="col-md-2 logo-image">
                    <figure>
                        <img src="/images/shareholders/acrecon_logo.png" alt="ACRECON Logo" width="512" height="512" />
                    </figure>
                </div>
                <p>Acrecon Limited is a private Ghanaian company providing investment advisory and financial consultancy
                    services.
                    AcreCon Limited currently holds <strong>5.45%</strong> shareholding in NTHC Limited.</p>


                <h3>NTHC Provident Fund</h3>
                <div className="col-md-2 logo-image">
                    <figure>
                        <img src="/images/shareholders/pf_logo.png" alt="PF Logo" width="512" height="512" />
                    </figure>
                </div>
                <p>Staff of NTHC Group got the opportunity to own part of the Company in February 2001, through the staff
                    Provident Fund.
                    NTHC Provident Fund currently holds <strong>2.09%</strong> shareholding in NTHC Limited.</p>
            </div>
        </div>
    )
}
function Subsidiaries() {
    return (
        <div className='our-subsidiaries'>
            <h1>NTHC Group</h1>
            <p>NTHC Group is made up NTHC Limited and six(6) subsidiary companies.</p>
            <p><h3>Subsidiaries</h3></p>
            <ol type="1">
                <li>
                    <p>NTHC Asset Management Limited</p>
                </li>

                <li>
                    <p>NTHC Trustees Limited</p>
                </li>

                <li>
                    <p>NTHC Registrar Limited</p>
                </li>

                <li>
                    <p>NTHC Securities Limited</p>
                </li>

                <li>
                    <p>NTHC Commodities Limited</p>
                </li>

                <li>
                    <p>NTHC Properties Limited</p>
                </li>
            </ol>
        </div>
    )
}
function OperatingStructure() {
    return (
        <div className='operating-structure'>
            <h1> Operating Structure</h1>
            <p>NTHC Group comprises the holding Company NTHC Limited and six wholly-owned subsidiaries. The Group is
                managed at the Holding Company level by a Board of Directors with representation from Institutional
                Shareholders.
            </p>
            <p>
                Each Subsidiary is managed by a Board of Directors made up of independent, non executive and executive
                directors.
            </p>

            <p>
                <figure class="opt-img">
                    <img src="/images/nthc_group.jpg" alt="SIC Logo" width="1195" height="860" />
                </figure>
            </p>

        </div>
    )
}
function TrackRecord() {
    return (
        <div className='track-record'>
            <h1>Our Track Record</h1>
            <div class="track-record">
                <div class="track-record-box">
                    <img alt="" src="/images/tombstones/tomb_1.png" />
                </div>
                <div class="track-record-box">
                    <img alt="" src="/images/tombstones/tomb_3.png" />
                </div>
                <div class="track-record-box">
                    <img alt="" src="/images/tombstones/tomb_4.png" />
                </div>
                <div class="track-record-box">
                    <img alt="" src="/images/tombstones/tomb_7.png" />
                </div>
                <div class="track-record-box">
                    <img alt="" src="/images/tombstones/tomb_2.png" />
                </div>
            </div>
        </div>
    )
}

